import { useQuery } from "@tanstack/react-query";

import type { BillingEntitlementResponse } from "~/features/billing/types";
import { useApiClient } from "~/hooks/use-api-client";

interface UseBillingEntitlementOptions {
    enabled?: boolean;
}

export function useBillingEntitlement(
    options: UseBillingEntitlementOptions = {},
) {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: ["billing", "entitlement"],
        queryFn: async () => {
            const response = await apiClient.get("/billing/entitlement");

            if (response.status === 401) {
                return {
                    enforced: false,
                    entitlement: null,
                } satisfies BillingEntitlementResponse;
            }

            if (!response.ok) {
                const data = await response.json().catch(() => ({}));
                throw new Error(
                    typeof data?.error === "string"
                        ? data.error
                        : "Failed to load billing entitlement",
                );
            }

            return (await response.json()) as BillingEntitlementResponse;
        },
        staleTime: 60_000,
        enabled: options.enabled ?? true,
    });
}
